import { CheckInput } from '@octano/global-ui';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { EventValues } from '../../views/AcademicStructure/periods/event/EventForm';

interface YesNoToggleProps {
  label: string;
  formKey: keyof EventValues;
  rules?: any;
}

export const YesNoToggleInput: React.FC<YesNoToggleProps> = ({
  label,
  formKey,
  rules,
}) => {
  const {
    watch,
    setValue,
    formState: { errors },
    register,
  } = useFormContext<EventValues>();

  const checked = watch(formKey);
  const error = errors[formKey];

  const handleChange = (value: boolean) => {
    setValue(formKey, value, { shouldValidate: true });
  };

  return (
    <div className="">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <div className="d-flex flex-row" style={{ gap: '2rem' }}>
        <input type="hidden" {...register(formKey, !!rules ? rules : {})} />
        <CheckInput
          name={`${String(formKey)}_yes`}
          label="Sí"
          value={checked === true}
          onChange={() => handleChange(true)}
        />
        <CheckInput
          name={`${String(formKey)}_no`}
          label="No"
          value={checked === false}
          onChange={() => handleChange(false)}
        />
      </div>
      {error && (
        <p className="text-sm text-red" style={{ marginTop: '-1rem' }}>
          {error.message?.toString()}
        </p>
      )}
    </div>
  );
};
